<div class="regularizacion-page" data-testid="regularization-page">
    <div class="regularizacion-header">
        <div class="regularizacion-header__brand">
            <img src="assets/media/logos/logo-sf.png" alt="SimpleFactura" class="regularizacion-header__logo"
                onerror="this.style.display='none'" />
        </div>
        <div class="regularizacion-header__info">
            <h2 class="regularizacion-header__title">Renueva tu plan</h2>
            <p class="regularizacion-header__subtitle">
                Tu plan ya no se encuentra vigente. Renueva o elige otro plan para volver a utilizar SimpleFactura.
            </p>
        </div>
        <button type="button" class="btn btn-outline-secondary btn-sm regularizacion-header__salir"
            (click)="salir()">
            <i class="fas fa-sign-out-alt mr-1"></i> Salir
        </button>
    </div>

    <div class="alert alert-danger d-flex align-items-center mx-4 my-3" role="alert">
        <i class="fas fa-ban fa-lg mr-3 flex-shrink-0"></i>
        <div>
            <ng-container *ngIf="emisoresInactivos.length === 1">
                La empresa <strong>{{ emisoresInactivos[0]?.razonSocial }}</strong>
                tiene su plan sin vigencia. Puedes renovarlo para volver a operar desde hoy.
            </ng-container>
            <ng-container *ngIf="emisoresInactivos.length > 1">
                Tienes <strong>{{ emisoresInactivos.length }} empresas con planes sin vigencia</strong>.
                Selecciona la empresa cuyo plan deseas renovar.
            </ng-container>
        </div>
    </div>
    <div *ngIf="emisoresInactivos.length > 1" class="regularizacion-selector mx-4 mb-3">
        <label class="font-weight-bold mb-1">Empresa a renovar:</label>
        <ng-select
            [items]="emisoresInactivos"
            bindLabel="razonSocial"
            [clearable]="false"
            [(ngModel)]="currentEmisorObject"
            (change)="onEmisorSeleccionado($event)"
            placeholder="Seleccione una empresa">
        </ng-select>
    </div>

    <ngx-loading
        [show]="loading"
        [config]="{ backdropBorderRadius: '3px' }"
        [template]="customLoadingTemplate">
    </ngx-loading>
    <ng-template #customLoadingTemplate></ng-template>

    <app-deuda-gracia-card
        *ngIf="!loading && tieneDeudaGraciaPendiente"
        class="mx-4"
        [deuda]="deudaGraciaPendiente"
        [pagando]="pagandoDeudaGracia"
        mensaje="Debes pagar primero el uso realizado durante el periodo de gracia. Después podrás renovar tu plan desde la fecha del nuevo pago."
        (pagar)="pagarDeudaGracia()">
    </app-deuda-gracia-card>

    <app-deuda-adicional-card
        *ngIf="!loading && tieneDeudaAdicionalPendiente"
        class="mx-4"
        [deuda]="deudaAdicionalPendiente"
        [pagando]="pagandoDeudaAdicional"
        mensaje="Debes pagar el total de esta deuda para poder completar la renovación de tu plan. No se permiten pagos parciales."
        (pagar)="pagarDeudaAdicional()">
    </app-deuda-adicional-card>

    <div *ngIf="!loading && planActual" class="regularizacion-content">
        <div class="regularizacion-tabs">
            <button
                type="button"
                class="regularizacion-tab"
                data-testid="regularization-mode-renew"
                [class.regularizacion-tab--active]="modo === 'regularizar'"
                (click)="setModo('regularizar')">
                <i class="fas fa-redo mr-2"></i>
                Renovar mi plan
                <small class="d-block mt-1">Renueva el mismo plan que tenías</small>
            </button>
            <button
                type="button"
                class="regularizacion-tab"
                data-testid="regularization-mode-change"
                [class.regularizacion-tab--active]="modo === 'cambiar'"
                (click)="setModo('cambiar')">
                <i class="fas fa-exchange-alt mr-2"></i>
                Elegir otro plan
                <small class="d-block mt-1">Elige un plan diferente</small>
            </button>
        </div>
        <div class="row mt-4">
            <div class="col-lg-8">

                <app-planes-bloque
                    *ngIf="planActual && planes"
                    [planes]="modo === 'regularizar' ? planes : planesNuevos"
                    [type]="modo === 'regularizar' ? 'blocked' : 'change'"
                    [planSeleccionado]="planSeleccionado"
                    [planUsuario]="planActual"
                    (actualizarPlan)="updatePlan($event)">
                </app-planes-bloque>

                <div class="card border-width-3 mt-3 border-radius-0">
                    <div class="card-body">
                        <p class="font-weight-bold mb-2">Datos para emisión de la factura:</p>
                        <div *ngIf="datosFacturacion">
                            <div class="row align-items-center">
                                <div class="col-md-5">
                                    <ng-select
                                        [items]="rowsDatosFacturacion"
                                        [clearable]="false"
                                        placeholder="Seleccione empresa"
                                        bindLabel="razonSocial"
                                        [(ngModel)]="datosFacturacion">
                                    </ng-select>
                                </div>
                                <div class="col-md-7 mt-2 mt-md-0">
                                    <div class="d-flex flex-wrap small text-muted">
                                        <div class="mr-4">
                                            <div><strong>RUT:</strong> {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</div>
                                            <div><strong>Giro:</strong> {{ datosFacturacion.giro }}</div>
                                            <div><strong>Comuna:</strong> {{ datosFacturacion.comuna }}</div>
                                        </div>
                                        <div>
                                            <div><strong>Razón Social:</strong> {{ datosFacturacion.razonSocial }}</div>
                                            <div><strong>Dirección:</strong> {{ datosFacturacion.dirFact }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="planActual && nuevaFechaCaducidad" class="card border-width-3 mt-3 border-radius-0">
                    <div class="card-body small">
                        <p *ngIf="!planActual.isDemo && !resumenCuenta?.esReactivacion">
                            Tu plan venció el <strong>{{ planActual.fechaCaducidad | date:'dd/MM/yyyy' }}</strong>.
                            Su nueva vigencia sería hasta el
                            <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.
                            El tiempo se calcula desde el vencimiento de tu plan.
                        </p>
                        <p *ngIf="resumenCuenta?.esReactivacion">
                            Tu nueva vigencia comenzará con este pago
                            (<strong>{{ fechaActual.toDate() | date:'dd/MM/yyyy' }}</strong>) y se extenderá hasta el
                            <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.
                        </p>
                        <p *ngIf="planActual.isDemo">
                            Tu plan gratuito terminó el <strong>{{ planActual.fechaCaducidad | date:'dd/MM/yyyy' }}</strong>.
                            La vigencia será desde hoy
                            (<strong>{{ fechaActual.toDate() | date:'dd/MM/yyyy' }}</strong>) hasta el
                            <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.
                        </p>
                        <p *ngIf="nuevaFechaCaducidad.isBefore(fechaActual) && !planActual.isDemo && !resumenCuenta?.esReactivacion" class="text-danger">
                            Con este pago regularizas tu plan, pero aún mantendrías una mora de
                            {{ nuevaFechaCaducidad.diff(fechaActual, 'days') * -1 }} días.
                        </p>
                    </div>
                </div>

            </div>
            <div class="col-lg-4">
                <app-resumen-bloque
                    *ngIf="planActual && certificaciones"
                    [planSeleccionado]="planSeleccionado"
                    [planes]="planes"
                    [certificaciones]="certificaciones"
                    [type]="'extend'"
                    [planUsuario]="planActual"
                    (actualizarResumen)="notifyResumen($event)">
                </app-resumen-bloque>

                <div class="regularizacion-actions mt-3">
                    <div *ngIf="tieneDeudaGraciaPendiente" class="alert alert-warning small mb-2">
                        <i class="fas fa-exclamation-triangle mr-1"></i>
                        Debes pagar el uso del periodo de gracia antes de renovar el plan.
                    </div>
                    <div *ngIf="tieneDeudaAdicionalPendiente" class="alert alert-warning small mb-2">
                        <i class="fas fa-exclamation-triangle mr-1"></i>
                        Mantienes <strong>$ {{ deudaAdicionalPendiente.totalPendiente | number:'1.0-0':'es-CL' }}</strong>
                        en facturas pendientes por adicionales. Debes pagarlas antes de completar la renovación.
                    </div>
                    <small class="text-muted d-block mb-2">
                        Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de pagar.
                    </small>
                    <button
                        type="button"
                        class="btn btn-primary btn-block btn-lg"
                        data-testid="regularization-plan-submit"
                        [disabled]="!resumenCuenta || loading || solicitandoFechaCertificacion || esMismoPlanEnCambio || tieneDeudaAdicionalPendiente || tieneDeudaGraciaPendiente"
                        (click)="pagar()">
                        <i class="fas fa-credit-card mr-2"></i>
                        <ng-container *ngIf="modo === 'regularizar'">Renovar y pagar</ng-container>
                        <ng-container *ngIf="modo === 'cambiar'">Contratar nuevo plan y pagar</ng-container>
                    </button>
                </div>
            </div>

        </div>
    </div>

</div>
